import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import {shouldBeArray} from 'js/shared/utils';

import SectionLoader from '../SectionLoader';
import ItemsColumns from '../ItemsColumns';

import styles from './ActivitiesAndWellbeingSection.module.scss'

const cx = classnames.bind(styles);

const reformatData = {
  sports: (reducer, data) => {
    const items = shouldBeArray(data.list);
    items.forEach(function (item, i) {
      const onSiteItems = shouldBeArray(item.list)?.map(el => ({...el, name: el.label}))
      reducer.push({
        id: `${data.id}:${i}`,
        icon: data.icon,
        label: item.label,
        facilities: [
          ...(item.onsitelabel && onSiteItems.length ? [{
            name: item.onsitelabel,
            list: onSiteItems
          }] : [])
        ]
      })
    })
  },
  entertainment: (reducer, data) => {
    const items = [];
    const onSiteItems = shouldBeArray(data.onSite?.list)?.map(el => ({...el, name: el.label}));
    const nearByItems = shouldBeArray(data.nearBy?.list)?.map(el => ({...el, name: el.label}));

    if (data.onSite?.label && onSiteItems.length) {
      items.push({
        id: `${data.id}:onSite`,
        name: data.onSite?.label,
        list: onSiteItems,
      })
    }

    if (data.nearBy?.label && nearByItems.length) {
      items.push({
        id: `${data.id}:nearBy`,
        name: data.nearBy?.label,
        list: nearByItems,
      })
    }

    reducer.push({
      id: data.id,
      icon: data.icon,
      label: data.label,
      facilities: items,
    })
  },
  tourism: (reducer, data) => {
    reducer.push({
      id: data.id,
      icon: data.icon,
      label: data.label,
      facilities: data.list,
    })
  },
  pools: (reducer, data) => {
    data?.list?.forEach((pool, i) => {
      reducer.push({
        id: `${data.id}:${i}`,
        icon: data.icon,
        label: pool.label,
        facilities: shouldBeArray(pool.nested)?.map(el => ({...el, name: el.label}))
      })
    })
  },
  wellbeing: (reducer, data) => {
    const isContentExist = shouldBeArray(data.list)?.some(el => el?.list?.length > 0)
    if (isContentExist) {
      reducer.push({
        id: data.id,
        icon: data.icon,
        label: data.label,
        facilities: shouldBeArray(data.list)?.map(el => ({
          ...el,
          name: el.label,
          list: shouldBeArray(el.list)?.map(el => ({...el, name: el.label})),
        }))
      })
    }
  },
  fitnessCenters: (reducer, data) => {
    shouldBeArray(data.list)?.forEach((el, i) => {
      reducer.push({
        id: `${data.id}:${i}`,
        icon: data.icon,
        label: el.label,
        paying: el.paying,
        facilities: shouldBeArray(el.nested)?.map(el => ({...el, name: el.label})),
      })
    })
  }
}

const prepareItems = function (data) {
  return Object.keys(data)
    .map(id => ({
      id,
      ...data[id],
    }))
    .sort((a, b) => b.order > a.order ? -1 : 1)
}

const updateKeysForTemplate = function (reducer, data) {
  if (data.id in reformatData) {
    reformatData[data.id](reducer, data)
  }
  return reducer
}

const ActivitiesAndWellbeingSection = function ({
  isLoading,
  info,
  className
}) {

  const itemsToShow = useMemo(function () {
    if (!info) return [];
    return prepareItems(info).reduce(updateKeysForTemplate, []);
  }, [info]);
  return (
    <div className={cx('root', className)}>
      {isLoading && (<SectionLoader />)}
      {!isLoading && (<ItemsColumns items={itemsToShow}/>)}
    </div>
  )
}


ActivitiesAndWellbeingSection.propTypes = {
  data: PropTypes.any
}

export default ActivitiesAndWellbeingSection;
